import React from 'react'
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../../components/commonClass/Session';
import { fetchIp } from '../../../../components/commonClass/CommonFunctions';

const OnHoldCancellation = ({ holdCancelModal, setHoldCancelModal, tboBookingId, setCancellationMessage, setShowCancelMessageModel }) => {

    const dispatch = useDispatch();

    const proceedtoCancel = async () => {
        dispatch(loaderActions.start());
        const statusoftoken = await verifytoken();
        if (statusoftoken) {
            const userData = GetLocalStorage();
            const userip = await fetchIp();
            if (userip?.status) {
                const payload = {
                    BookingMode: 5,
                    RequestType: 4,
                    BookingId: tboBookingId,
                    EndUserIp: userip?.data,
                    UserId: userData?.userMasterID,

                    CancellationTypeId: 0,
                    CancellationImagePath: "",
                    CancellationImageName: "",
                    Remarks: "",
                    GSTCharges: 0,
                    ETMFee: 0,
                    CancelCharges: 0,
                    ETMRefundAmount: 0,
                    IsConvenienceETMPercentage: false,
                    ChargeType: "",
                    CancelllationCharge: 0.00,
                    ConvenienceFeeETMCharge: 0,
                    ConvenienceCharges: 0,
                }

                const hotelsendchangerequest = await postUsersData("/customerui/v1/hotelsendchangerequest", payload)
                if (hotelsendchangerequest?.status) {
                    sessionStorage.setItem('isCancel', "true")
                    setShowCancelMessageModel(hotelsendchangerequest?.data?.message ? true : false);
                    setCancellationMessage(hotelsendchangerequest?.data?.message ? hotelsendchangerequest?.data?.message : "");
                    setHoldCancelModal(false);
                }
                else {
                    dispatch({ type: 'ALERTING', message: hotelsendchangerequest?.message || 'Cancellation failed' });
                }
                dispatch(loaderActions.end());
            }
        }
        else {
            dispatch(loaderActions.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            return;
        }
    }

    return (
        <div>
            <Modal
                show={holdCancelModal}
                onHide={() => setHoldCancelModal(false)}
                size="md"
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <div className='fs-5 fw-500'> Cancellation </div>
                </Modal.Header>
                <Modal.Body>
                    <center>
                        <h4> Do you want to cancel the booking ? </h4>
                        <button type="button" className='btn continueBtn mt-2' onClick={() => proceedtoCancel()}> Confirm </button>
                    </center>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default OnHoldCancellation
